import React from 'react';

export default function RecordingControls({
  isRecording, recordedBlob, recordedUrl, isPlaying,
  onStartRecording, onStopRecording, onDiscard, onSave,
}) {
  return (
    <div className="recording-controls">
      {/* No recording yet */}
      {!isRecording && !recordedBlob && (
        <button className="record-btn record-btn-start" onClick={onStartRecording}>
          <span style={{ fontSize: 22 }}>🎙️</span>
          Start Recording
        </button>
      )}

      {/* Currently recording */}
      {isRecording && (
        <button className="record-btn record-btn-stop" onClick={onStopRecording}>
          <span style={{ fontSize: 22 }}>⏹</span>
          Stop Recording
        </button>
      )}

      {/* Has a recording */}
      {recordedBlob && !isRecording && (
        <>
          <div className="recorded-playback">
            <p className="text-sm text-secondary" style={{ marginBottom: 6 }}>
              ✅ Recording complete — review it below:
            </p>
            <audio controls src={recordedUrl} style={{ width: '100%' }} />
          </div>

          <div className="playback-controls">
            <button className="btn btn-danger flex-1" onClick={onDiscard}>
              🗑️ Discard & Re-record
            </button>
            <button className="btn btn-primary flex-1" onClick={onSave}>
              💾 Save
            </button>
          </div>
        </>
      )}

      {!isRecording && !recordedBlob && (
        <p className="text-sm text-muted text-center" style={{ marginTop: 4 }}>
          🎵 Recording will sync with the backing track automatically
        </p>
      )}
    </div>
  );
}
